// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__du5sk","paramInput":"JobSimulator_paramInput__WRh3I","input":"JobSimulator_input__GnNYd"};